import React from "react";
import ShiftDatesDropdown from "./ShiftDatesDropdown";
import { DateShift } from "./types";

interface ShiftDatesMenuProps {
  trigger: JSX.Element;
  onShift: (shift: DateShift) => void;
  onPickStartDate: (date: Date) => void;
}

const ShiftDatesMenu: React.FC<ShiftDatesMenuProps> = ({
  trigger,
  onShift,
  onPickStartDate
}) => (
  <ShiftDatesDropdown
    trigger={trigger}
    selection={null}
    align="end"
    side="bottom"
    onSelect={(selection) => {
      if (selection.kind === "date") {
        onPickStartDate(selection.date);
        return;
      }
      onShift(selection.shift);
    }}
  />
);

export default ShiftDatesMenu;
